import React from 'react';
import { MdMenu, MdLogout } from 'react-icons/md';
import { logout, getCurrentUser } from '../../utils/auth';
import './Header.css';

const Header = ({ onLogout, onToggleSidebar }) => {
  const user = getCurrentUser();

  const handleLogout = () => {
    logout();
    onLogout();
  };

  return (
    <header className="header">
      <div className="header-left">
        <button className="hamburger-menu" onClick={onToggleSidebar}>
          <MdMenu />
        </button>
        <img src="/assets/jethro.svg" alt="Jethro" className="header-logo" />
        <h1>Digital ID Management</h1>
      </div>
      
      <div className="header-right">
        <div className="user-info">
          <span className="user-name">{user?.username}</span>
          <span className="user-role">{user?.role?.replace('_', ' ').toUpperCase()}</span>
        </div>
        <button onClick={handleLogout} className="logout-button">
          <MdLogout />
          <span>Logout</span>
        </button>
      </div>
    </header>
  );
};

export default Header;
